module.exports = {"id":"183249","name":"Raúl Bobadilla","rating":"76","photo":"./data/images/photos/1/183249.png","club":{"name":"Bor. M'gladbach","logo":"./data/images/clubs/Bor.M'gladbach.png"},"positions":["BU","MD"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RaulBobadilla0.json
// module id = 3548
// module chunks = 0